import { styled } from 'styled-components';

export const CityName = styled.h5`
  margin: 0;
  color: var(--color-numa-green--100);

  font: 500 16px / 20px var(--font-family-founders-grotesk);

  @media screen and (min-width: 768px) {
    font: 500 20px / 26px var(--font-family-founders-grotesk);
  }
  @media screen and (min-width: 1024px) {
    font: 500 16px / 20px var(--font-family-founders-grotesk);
  }
`;

export const OngoingTripTitle = styled.h5`
  font: var(--font-h3);
  color: var(--color-numa-black--400);
`;

export const PastCancelledTripTitle = styled.h5`
  font: var(--font-subtitle-2--bold);
  color: var(--color-numa-black--400);
`;

export const GuestName = styled.p`
  font: 400 16px var(--font-family-founders-grotesk);
  color: var(--color-numa-black--300);
  margin: 0;
`;

export const PropertyName = styled.h4`
  font: 500 24px / 26px var(--font-family-founders-grotesk);
  color: var(--color-numa-black--400);
`;

export const Dates = styled.div`
  font: 400 16px var(--font-family-founders-grotesk);
`;
